import {
  Autocomplete,
  Box,
  Button,
  Modal,
  TextField,
  styled,
} from "@mui/material";
import { makeStyles } from '@mui/styles';
import {
  APP_BACKGROUND_COLOR,
  APP_COLOR,
  APP_HOVER_COLOR,
  BORDER_COLOR,
  BUTTON_TEXT_COLOR,
  FONT_FAMILY,
  SKIP_BUTTON_BACKGROUND_COLOR,
  SKIP_BUTTON_TEXT_COLOR,
  TEXT_COLOR,
} from "../../theme";

export const WaveformContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const ContainerModal = styled(Modal)({ overflow: "auto" });

export const useStyles = makeStyles({
  customTextField: {
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  selectStyle: {
    fontFamily: FONT_FAMILY,
  },
});

export const UsernameSelectField = styled(Autocomplete)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: BORDER_COLOR,
      borderWidth: 2,
      height: 57,
    },
    "&:hover fieldset": {
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
    },
    "&.Mui-focused fieldset": {
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
    },
  },
});

export const EmailInviteTextField = styled(TextField)({
  width: "100%",
  fontFamily: FONT_FAMILY,
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: BORDER_COLOR,
      borderWidth: 2,
      height: 57,
    },
    "&:hover fieldset": {
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
    },
    "&.Mui-focused fieldset": {
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
    },
  },
});

export const ModalButton = styled(Button)({
  fontFamily: FONT_FAMILY,
  marginTop: 16,
  padding: 8,
  width: 110,
  textTransform: "none",
  color: "black",
  "&:hover": {
    backgroundColor: APP_HOVER_COLOR,
  },
  backgroundColor: APP_COLOR,
});

export const autoCompleteStlye = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: BORDER_COLOR,
      borderWidth: 2,
    },
    "&:hover fieldset": {
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
      border: `1px solid gray`,
    },
    "&.Mui-focused fieldset": {
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
      border: `1px solid gray`,
    },
  },
};

export const autoCompleteErrorStyle = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "red",
      borderWidth: 2,
    },
    "&:hover fieldset": {
      borderColor: "red",
    },
    "&.Mui-focused fieldset": {
      borderColor: "red",
    },
  },
};

export const styles = {
  uploadAudioTypography: {
    color: TEXT_COLOR,
    marginTop: "10px",
    marginBottom: "10px"
  } as const,
  addNoteTypography: {
    color: TEXT_COLOR,
    marginTop: "15px",
    marginBottom: "10px",
  } as const,
  noteContainer: {
    position: "absolute",
    bottom: "10px",
    right: "10px",
    fontSize: "12px",
    color: "grey",
  } as const,
  bpmContainer: {
    color: TEXT_COLOR,
    marginTop: "15px",
    marginBottom: "10px"
  } as const,
  spinner: {
    marginTop: 10,
    marginLeft: 10
  } as const,
  modalHeader: {
    fontFamily: FONT_FAMILY,
    fontSize: 20,
    fontWeight: "bold",
    flexGrow: 1,
    color: TEXT_COLOR,
  } as const,
  uploadTracksContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px"
  } as const,
  modalHeaderContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
  } as const,
  modalImagePlaceholder: {
    color: TEXT_COLOR,
    width: "30px",
    height: "30px",
  } as const,
  modalDescription: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: "white",
    borderColor: "white",
  } as const,
  modalBpmLabel: {
    color: TEXT_COLOR,
    marginBottom: 0,
    fontSize: 16,
    fontFamily: FONT_FAMILY,
    fontWeight: "500",
  } as const,
  headerIconContainer: {
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    marginBottom: "10px",
    backgroundColor: APP_COLOR,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,

  modalCreatorUsername: {
    display: "block",
    fontFamily: FONT_FAMILY,
    color: TEXT_COLOR,
    fontSize: 16,
    marginBottom: 8,
    fontWeight: 500,
  } as const,
  modalSubmitButton: {
    textTransform: "none",
    color: BUTTON_TEXT_COLOR,
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginY: 3,
    paddingY: 1,
    height: 50,
    width: "200px",
    marginRight: "20px"
  } as const,
  skipButton: {
    marginY: 3,
    width: "200px",
    paddingY: 1,
    height: 50,
    borderRadius: "var(--radius-md, 8px)",
    border:
      "1px solid var(--Component-colors-Components-Buttons-Secondary-button-secondary-border, #4C5155)",
    background: SKIP_BUTTON_BACKGROUND_COLOR,
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    color: SKIP_BUTTON_TEXT_COLOR,
    textTransform: "none",
  } as const,
  modalSubmitButtonText: {
    fontFamily: FONT_FAMILY,
    fontSize: 20,
    fontWeight: "400",
  } as const,
  postMessageModal: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: APP_BACKGROUND_COLOR,
    alignItems: "center",
    justifyContent: "center",
    padding: 40,
    position: "relative",
  } as const,
  postMessageModalIcon: {
    position: "absolute",
    top: 15,
    right: 15,
    color: APP_COLOR,
  } as const,
  waveform: {
    minWidth: "100%",
    overflow: "hidden",
    marginTop: "25px",
  } as const,
  trackControlsAndTrackDetailsContainer: {
    display: "flex",
    width: "auto",
    justifyContent: "space-between",
    padding: "0 5px 0 5px",
  } as const,
  linearProgress: {
    flexGrow: 1,
    marginBottom: 5,
    marginTop: 5,
    color: "#27B6CB",
  } as const,
  extensionContainer: {
    display: "flex",
    alignContent: "center",
    backgroundColor: "#203e5e",
    padding: "10px",
    borderRadius: "5px",
  } as const,
  removeAllFileButton: {
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    color: BUTTON_TEXT_COLOR,
    marginY: 2,
    boxShadow: "0 5px 25px 0 rgba(0, 0, 0, 0.6)",
    textTransform: "none",
    fontFamily: FONT_FAMILY,
  } as const,
  uploadFileContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: 20,
    marginBottom: 10,
  } as const,
  extensionNameContainer: {
    flexDirection: "column",
    marginLeft: 20,
    fontSize: 14,
    flexGrow: 1,
  } as const,
  AddTrackTextContainer: {
    marginLeft: 10,
    fontFamily: FONT_FAMILY,
    fontSize: "20px",
  } as const,
  progressContainer: {
    width: "100%",
    paddingY: 4,
    color: APP_COLOR,
  } as const,
  file: {
    height: 155,
    borderStyle: "dashed",
    borderWidth: "2px",
  } as const,
  fileLabel: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: TEXT_COLOR,
    borderColor: TEXT_COLOR,
    borderWidth: "1px",
  } as const,
  selectFieldStyle: {
    ".MuiOutlinedInput-notchedOutline": {
      borderColor: TEXT_COLOR,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: TEXT_COLOR,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: TEXT_COLOR,
    },
  } as const,
};

export const SelectVersionModalContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  border: "2px solid #000",
  // boxShadow: 24,
  padding: "15px",
  overflowY: "scroll",
  height: "90vh",
  [theme.breakpoints.down("md")]: {
    width: "80%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "90%",
  },
}));

export const TrackContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  marginBottom: "10px",
}));

export const CheckBoxContainer = styled(Box)(({ theme }) => ({
  alignSelf: "center",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const VersionsAndCollaboratorsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "10px 5px 5px 15px",
  marginTop: "5px",
  [theme.breakpoints.down("sm")]: {
    padding: "10px 5px 5px 10px",
    width: "310px",
  },
}));

export const MenuItemsContainer = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down("sm")]: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "-15px",
  },
}));

export const SortFilterContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "30px",
  flexWrap: "wrap",
  margin: "15px 0 25px, 0",
}));

export const SelectField = styled(Autocomplete)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#4B4F54",
      height: "100%",
    },
    "&:hover fieldset": {
      borderColor: TEXT_COLOR,
    },
    "&.Mui-focused fieldset": {
      borderColor: TEXT_COLOR,
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
    },
  },
});

export const CustomPaper = styled(Box)(({ theme }) => ({
  backgroundColor: "your_desired_color_here",
  "& ul": {
    margin: 0,
    padding: 0,
    listStyle: "none",
  },
}));
